const header = {
	headerToggle: function () {
		sangApp.selector('.hl-header .header-toggle').addEventListener('click', function () {
			sangApp.addClass(sangApp.selector('.hl-header'), 'sidenav-open')
		})
		sangApp.selector('.hl-header .header-overlay').addEventListener('click', function () {
			sangApp.removeClass(sangApp.selector('.hl-header'), 'sidenav-open')
		})
	},
	headerScroll: function () {
		let hl_header = sangApp.selector('.hl-header');
		if (window.matchMedia("(min-width: 1200px)").matches) {
			var lastScrollTop = 0;
			// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
			window.addEventListener("scroll", function () { // or window.addEventListener("scroll"....
				var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
				if (st > lastScrollTop) {
					hl_header.style.transform = 'translateY(-100%)';
					
				} else {
					sangApp.selector('.hl-header').style.transform = 'translateY(0)';
					
				}
				lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
			}, false);
		}
		window.addEventListener("scroll", function () {
			if (window.scrollY) {
				sangApp.addClass(hl_header,'is-active')
			} else {
				sangApp.removeClass(hl_header,'is-active')
			}
			
		})
	},
	headerInit: function () {
		header.headerToggle();
		header.headerScroll();
	}

};
